// import { Code, Palette, Smartphone, Globe, Server, Zap, ArrowRight } from "lucide-react";
// import { motion } from "framer-motion";

// export const AboutMe = () => {
//   const services = [
//     { 
//       title: "Web Design", 
//       icon: <Palette className="w-5 h-5" />,
//       description: "Creating visually appealing and user-friendly interfaces"
//     },
//     { 
//       title: "Front-End Development", 
//       icon: <Code className="w-5 h-5" />,
//       description: "Building responsive and interactive web applications"
//     },
//     { 
//       title: "E-Commerce Solutions", 
//       icon: <Globe className="w-5 h-5" />,
//       description: "Developing online stores with seamless shopping experiences"
//     },
//     { 
//       title: "Mobile Optimization", 
//       icon: <Smartphone className="w-5 h-5" />,
//       description: "Ensuring perfect functionality across all devices"
//     }
//   ];

//   const stats = [
//     { value: "5+", label: "Projects Completed" },
//     { value: "2+", label: "Years Experience" },
//     // { value: "100%", label: "Client Satisfaction" }
//   ];

//   return (
//     <section
//       id="about"
//       className="relative bg-white text-slate-900 py-24 px-6 scroll-mt-20 overflow-hidden"
//     >
//       <div className="max-w-7xl mx-auto relative z-10">
//         {/* Section Header */}
//         <motion.div
//           className="text-center mb-16"
//           initial={{ opacity: 0, y: -30 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.8 }}
//           viewport={{ once: false }}
//         >
//           <div className="inline-flex items-center justify-center mb-4">
//             <div className="w-12 h-0.5 bg-emerald-500 mr-4"></div>
//             <h2 className="text-4xl md:text-5xl font-bold text-slate-900">
//               About <span className="text-emerald-600">Me</span>
//             </h2>
//             <div className="w-12 h-0.5 bg-blue-600 ml-4"></div>
//           </div>
//           <p className="text-slate-600 mt-4 text-lg max-w-2xl mx-auto">
//             Passionate developer crafting digital experiences that make an impact
//           </p>
//         </motion.div>

//         <div className="grid lg:grid-cols-2 gap-16 items-center">
//           {/* Image with motion */}
//           <motion.div
//             initial={{ opacity: 0, x: -80 }}
//             whileInView={{ opacity: 1, x: 0 }}
//             transition={{ duration: 0.8, ease: "easeOut" }}
//             viewport={{ once: false }}
//             className="relative"
//           >
//             <div className="absolute -inset-4 bg-gradient-to-r from-blue-100 to-emerald-100 rounded-2xl transform rotate-3"></div>
//             <img
//               src="https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?q=80&w=2069&auto=format&fit=crop"
//               alt="Developer at work"
//               className="rounded-2xl shadow-lg w-full relative z-10 transform hover:scale-105 transition duration-500 ease-in-out"
//             />
//           </motion.div>

//           {/* Content with motion */}
//           <motion.div
//             initial={{ opacity: 0, x: 80 }}
//             whileInView={{ opacity: 1, x: 0 }}
//             transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
//             viewport={{ once: false }}
//           >
//             <h3 className="text-3xl font-bold text-slate-900 mb-6">
//               Crafting Digital Excellence
//             </h3>
//             <p className="text-lg text-slate-700 mb-6 leading-relaxed">
//               I'm <strong className="text-blue-600">Momin</strong>, a passionate full-stack developer with expertise in modern web technologies. With over <strong>2+ years</strong> of experience, I specialize in creating high-performance websites using <strong>React, Next.js, Node.js</strong>, and modern CSS frameworks.
//             </p>
            
//             <p className="text-lg text-slate-700 mb-8 leading-relaxed">
//               I partner with businesses to establish their digital presence with websites that are not just visually stunning but also optimized for performance, accessibility, and conversion.
//             </p>

//             {/* Stats */}
//             <div className="grid grid-cols-3 gap-6 mb-8">
//               {stats.map((stat, idx) => (
//                 <motion.div
//                   key={idx}
//                   initial={{ opacity: 0, y: 20 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   transition={{ duration: 0.5, delay: idx * 0.1 }}
//                   viewport={{ once: false }}
//                   className="text-center p-4 bg-slate-50 rounded-lg"
//                 >
//                   <div className="text-2xl font-bold text-emerald-600">{stat.value}</div>
//                   <div className="text-sm text-slate-600">{stat.label}</div>
//                 </motion.div>
//               ))}
//             </div>

//             {/* Services Grid */}
//             <div className="grid sm:grid-cols-2 gap-4 mb-8">
//               {services.map((service, idx) => (
//                 <motion.div
//                   key={idx}
//                   initial={{ opacity: 0, y: 20 }}
//                   whileInView={{ opacity: 1, y: 0 }}
//                   transition={{ duration: 0.5, delay: idx * 0.1 }}
//                   viewport={{ once: false }}
//                   className="flex items-start gap-3 p-4 bg-slate-50 rounded-lg hover:bg-slate-100 transition-colors"
//                 >
//                   <div className="p-2 bg-gradient-to-r from-blue-500 to-emerald-500 text-white rounded-lg">
//                     {service.icon}
//                   </div>
//                   <div>
//                     <h4 className="font-semibold text-slate-900">{service.title}</h4>
//                     <p className="text-sm text-slate-600">{service.description}</p>
//                   </div>
//                 </motion.div>
//               ))}
//             </div>

//             {/* Call to action */}
//             <motion.div
//               initial={{ opacity: 0 }}
//               whileInView={{ opacity: 1 }}
//               transition={{ delay: 0.6 }}
//               viewport={{ once: false }}
//               className="flex gap-4"
//             >
//               <a
//                 href="#portfolio"
//                 className="flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-blue-600 to-emerald-600 text-white font-medium rounded-lg hover:shadow-lg transition-all duration-300"
//               >
//                 View My Work
//                 <ArrowRight className="w-4 h-4" />
//               </a>
//               <a
//                 href="#contact"
//                 className="px-6 py-3 bg-white border border-slate-300 text-slate-900 font-medium rounded-lg hover:bg-slate-50 transition-all duration-300"
//               >
//                 Let's Talk
//               </a>
//             </motion.div>
//           </motion.div>
//         </div>
//       </div>
//     </section>
//   );
// };


import { Code, Palette, Smartphone, Globe, Server, Zap, ArrowRight, Target, Users, Award } from "lucide-react";
import { motion } from "framer-motion";

export const AboutMe = () => {
  const services = [
    { 
      title: "Web Design", 
      icon: <Palette className="w-6 h-6" />,
      description: "Creating visually appealing and user-friendly interfaces"
    },
    { 
      title: "Front-End Development", 
      icon: <Code className="w-6 h-6" />,
      description: "Building responsive and interactive web applications"
    },
    { 
      title: "E-Commerce Solutions", 
      icon: <Globe className="w-6 h-6" />,
      description: "Developing online stores with seamless shopping experiences"
    },
    { 
      title: "Mobile Optimization", 
      icon: <Smartphone className="w-6 h-6" />,
      description: "Ensuring perfect functionality across all devices"
    }
  ];

  const stats = [
    { value: "20+", label: "Projects Completed", icon: <Target className="w-5 h-5" /> },
    { value: "3+", label: "Years Experience", icon: <Award className="w-5 h-5" /> },
    { value: "100%", label: "Client Satisfaction", icon: <Users className="w-5 h-5" /> }
  ];

  return (
    <section
      id="about"
      className="relative bg-gradient-to-br from-gray-50 to-gray-100 text-gray-800 py-24 px-6 scroll-mt-20 overflow-hidden"
    >
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-40 h-40 bg-blue-500 rounded-full opacity-5 -translate-x-20 -translate-y-20"></div>
      <div className="absolute bottom-0 right-0 w-60 h-60 bg-emerald-500 rounded-full opacity-5 translate-x-20 translate-y-20"></div>
      
      <div className="max-w-7xl mx-auto relative z-10">
        {/* Section Header */}
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: -30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <motion.div 
            className="inline-flex items-center justify-center mb-4"
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <div className="w-16 h-1 bg-gradient-to-r from-blue-600 to-emerald-500 mr-4 rounded-full"></div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-800">
              About <span className="bg-gradient-to-r from-blue-600 to-emerald-500 text-transparent bg-clip-text">Me</span>
            </h2>
            <div className="w-16 h-1 bg-gradient-to-r from-emerald-500 to-blue-600 ml-4 rounded-full"></div>
          </motion.div>
          <motion.p
            className="text-lg text-gray-600 mt-4 max-w-2xl mx-auto"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            viewport={{ once: true }}
          >
            Passionate developer crafting digital experiences that make an impact
          </motion.p>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image with motion */}
          <motion.div
            initial={{ opacity: 0, x: -80 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true }}
            className="relative"
          >
            <div className="absolute -inset-4 bg-gradient-to-r from-blue-100 to-emerald-100 rounded-2xl transform rotate-3 opacity-60"></div>
            <div className="relative z-10 rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1573164713714-d95e436ab8d6?q=80&w=2069&auto=format&fit=crop"
                alt="Developer at work"
                className="w-full h-auto transform hover:scale-105 transition duration-700 ease-in-out"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300"></div>
            </div>
            
            {/* Floating elements */}
            <div className="absolute -bottom-4 -left-4 w-16 h-16 z-20 bg-white rounded-xl shadow-lg flex items-center justify-center">
              <Zap className="w-8 h-8 text-yellow-500" fill="currentColor" />
            </div>
            <div className="absolute -top-4 -right-4 w-12 h-12 z-20 bg-white rounded-xl shadow-lg flex items-center justify-center">
              <Server className="w-6 h-6 text-blue-600" />
            </div>
          </motion.div>

          {/* Content with motion */}
          <motion.div
            initial={{ opacity: 0, x: 80 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
            viewport={{ once: true }}
            className="space-y-8"
          >
            <div>
              <h3 className="text-3xl font-bold text-gray-800 mb-6">
                Crafting Digital Excellence
              </h3>
              <div className="space-y-4">
                <p className="text-lg text-gray-600 leading-relaxed">
                  I'm <strong className="text-blue-600">Momin Hussain</strong>, a passionate full-stack developer with expertise in modern web technologies. With over <strong>3+ years</strong> of experience, I specialize in creating high-performance websites using <strong>React, Next.js, Node.js</strong>, and modern CSS frameworks.
                </p>
                
                <p className="text-lg text-gray-600 leading-relaxed">
                  I partner with businesses to establish their digital presence with websites that are not just visually stunning but also optimized for performance, accessibility, and conversion.
                </p>
              </div>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-3 gap-4">
              {stats.map((stat, idx) => (
                <motion.div
                  key={idx}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: idx * 0.1 }}
                  viewport={{ once: true }}
                  className="bg-white p-4 rounded-xl shadow-lg text-center border border-gray-100 hover:shadow-xl transition-all duration-300"
                >
                  <div className="flex justify-center mb-2">
                    <div className="p-2 bg-blue-100 rounded-lg text-blue-600">
                      {stat.icon}
                    </div>
                  </div>
                  <div className="text-2xl font-bold text-gray-800 mb-1">{stat.value}</div>
                  <div className="text-sm text-gray-600">{stat.label}</div>
                </motion.div>
              ))}
            </div>

            {/* Services Grid */}
            <div>
              <h4 className="text-xl font-semibold text-gray-800 mb-4">What I Offer</h4>
              <div className="grid sm:grid-cols-2 gap-4">
                {services.map((service, idx) => (
                  <motion.div
                    key={idx}
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5, delay: idx * 0.1 }}
                    viewport={{ once: true }}
                    className="flex items-start gap-4 p-4 bg-white rounded-xl shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 group"
                  >
                    <div className="p-3 bg-gradient-to-r from-blue-500 to-emerald-500 text-white rounded-xl group-hover:scale-110 transition-transform duration-300">
                      {service.icon}
                    </div>
                    <div>
                      <h4 className="font-semibold text-gray-800 mb-1">{service.title}</h4>
                      <p className="text-sm text-gray-600">{service.description}</p>
                    </div>
                  </motion.div>
                ))}
              </div>
            </div>

            {/* Call to action */}
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.6 }}
              viewport={{ once: true }}
              className="flex flex-col sm:flex-row gap-4 pt-4"
            >
              <motion.a
                href="#portfolio"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="flex items-center justify-center gap-2 px-8 py-4 bg-gradient-to-r from-blue-600 to-emerald-600 text-white font-semibold rounded-xl hover:shadow-xl transition-all duration-300 shadow-lg"
              >
                View My Work
                <ArrowRight className="w-5 h-5" />
              </motion.a>
              <motion.a
                href="#contact"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                className="flex items-center justify-center px-8 py-4 bg-white border border-gray-300 text-gray-800 font-semibold rounded-xl hover:bg-gray-50 hover:shadow-lg transition-all duration-300"
              >
                Let's Talk
              </motion.a>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};